"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuConfigurationLinksTooltip = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const SankeyUtils_1 = require("./SankeyUtils");
const MenuConfigurationLinksTooltip = (data, set_data, multi_selected_links, t, menu_for_modal) => {
    const content = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_part_title_1' }, t('Noeud.IB')),
        react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Flux.tooltips.IB') },
            react_1.default.createElement(react_2.Textarea, { rows: 10, value: multi_selected_links.current.length > 0 && multi_selected_links.current[0].tooltip_text ? multi_selected_links.current[0].tooltip_text : '', onChange: evt => {
                    multi_selected_links.current.forEach(l => l.tooltip_text = evt.target.value);
                } })));
    return menu_for_modal ? [content] :
        [
            react_1.default.createElement(react_2.Tab, null,
                react_1.default.createElement(react_2.Box, { layerStyle: 'submenuconfig_tab' }, t('Flux.IS'))),
            react_1.default.createElement(react_2.TabPanel, null, content)
        ];
};
exports.MenuConfigurationLinksTooltip = MenuConfigurationLinksTooltip;
